import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Button,
  Input,
  Flex,
  InputGroup,
  // InputLeftElement,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  FormControl,
  FormLabel,
  Textarea,
  Text,
  ModalFooter,
  ModalCloseButton,
  // Badge,
  Checkbox,
} from '@chakra-ui/react';
import { ViewIcon, CheckIcon, SmallCloseIcon } from '@chakra-ui/icons';
import { FiPlusCircle, FiTrash2, FiEdit } from 'react-icons/fi';
import { toast } from 'react-toastify';
import TableContainer from 'components/common/TableContainer';
import httpInjectorService from 'services/http-injector.service';
import Cookies from 'js-cookie';
import { decryptData } from 'utils/crypto';
import { Header } from 'stories/Header';
import { FcViewDetails } from 'react-icons/fc';
// import { Row, Col }from 'reactstrap';
import { Row, Col, Badge } from 'reactstrap';
import { Empty } from 'antd';
import { BulletList } from 'react-content-loader';
import { demoWfhRequests } from 'components/demodata/Dummydata';

const WFHRequest = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [requestType] = useState('WFH Request');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [reason, setReason] = useState('');
  const [workFromHome, setWorkFromHome] = useState([]);
  const [editRequest, setEditRequest] = useState(null);
  const role_id = decryptData(Cookies.get('role_id'));
  const user_role = decryptData(Cookies.get('userRole'));

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [selectedRequests, setSelectedRequests] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [loading, setLoading] = useState(true);
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const {
    isOpen: isViewOpen,
    onOpen: onviewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  // Inside your WFHRequest component
  const isDateOverlap = (newStart, newEnd, currentId) => {
    return workFromHome.some((req) => {
      if (req.id === currentId) return false;
      if (req.status === 'Deleted') return false;
      const existingStart = new Date(req.start_date);
      const existingEnd = new Date(req.end_date);

      // Check for any overlap
      return newStart <= existingEnd && existingStart <= newEnd;
    });
  };
  const [viewRequest, setViewRequest] = useState(null);

  //toggle for all
  const toggleAllSelection = () => {
    if (allSelected) {
      setSelectedRequests([]);
    } else {
      const pendingIds = workFromHome
        .filter((req) => req.status === 'Pending')
        .map((req) => req.id);
      setSelectedRequests(pendingIds);
    }
    setAllSelected(!allSelected);
  };

  //Toggle single row
  const toggleRowSelection = (id) => {
    setSelectedRequests((prev) =>
      prev.includes(id) ? prev.filter((reqId) => reqId !== id) : [...prev, id],
    );
  };

  //kepp allselected chekbox in sync
  useEffect(() => {
    const pendingIds = workFromHome
      .filter((req) => req.status === 'Pending')
      .map((req) => req.id);
    setAllSelected(
      pendingIds.length > 0 &&
        pendingIds.every((id) => selectedRequests.includes(id)),
    );
  }, [selectedRequests, workFromHome]);

  const handleBulkApprove = async () => {
    if (selectedRequests.length === 0) return;

    const results = await Promise.all(
      selectedRequests.map(async (id) => {
        const req = workFromHome.find((r) => r.id === id);
        // return updateStatus([id], 'Approved', [req?.user_id], false);
        return updateStatus(id, 'Approved', req?.user_id, false);
      }),
    );

    const successCount = results.filter(Boolean).length;
    const failCount = results.length - successCount;

    if (successCount > 0) {
      toast.success(`${successCount} request(s) approved successfully`);
    }
    if (failCount > 0) {
      toast.error(`${failCount} request(s) failed`);
    }

    setSelectedRequests([]);
    fetchWfhRequest();
  };

  const handleBulkReject = async () => {
    if (selectedRequests.length === 0) return;

    const results = await Promise.all(
      // selectedRequests.map((id) => updateStatus(id, 'Rejected', false)),
      selectedRequests.map((id) => {
        const req = workFromHome.find((r) => r.id === id);
        return updateStatus(id, 'Rejected', req?.user_id, false);
      }),
    );

    const allSuccess = results.every(Boolean);

    const successCount = results.filter(Boolean).length;
    const failCount = results.length - successCount;

    if (successCount > 0) {
      toast.success(`${successCount} request(s) rejected successfully`);
    }
    if (failCount > 0) {
      toast.error(`${failCount} request(s) failed`);
    }

    setSelectedRequests([]);
    fetchWfhRequest();
  };
  // FETCH API (post)
  const fetchWfhRequest = async () => {
    setLoading(true);
    try {
    const isDemoMode = localStorage.getItem('demoMode') === 'true';

    if (isDemoMode) {
      setWorkFromHome(demoWfhRequests);
      return;
      }
      const response = await httpInjectorService.getWfhRequest();
      if (response?.status === 'success') {
        const apiData = response?.data;

        if (Array.isArray(apiData)) {
          setWorkFromHome(apiData);
        } else if (Array.isArray(apiData?.data)) {
          setWorkFromHome(apiData.data);
        } else {
          setWorkFromHome([]);
        }
      } else {
        setWorkFromHome([]);
      }
    } catch (error) {
      toast.error('Something went wrong');
      setWorkFromHome([]);
    } finally {
      setLoading(false);
    }
  };

  // SUBMIT REQUEST
  const submitRequest = async () => {
    if (!startDate || !endDate || !reason) {
      toast.error('All fields are required to fill');
      return;
    }
    if (!reason || reason.length < 4 || /^[.@$#]/.test(reason)) {
      toast.error(
        'Reason must be at least 4 characters and cannot start with ., @, $, #',
      );
      return;
    }

    const newStart = new Date(startDate);
    const newEnd = new Date(endDate);

    // Check overlap with ALL existing requests (any status)
    const isOverlap = workFromHome.some((req) => {
      if (req.status === 'Deleted') return false; //  ignore deleted
      const existingStart = new Date(req.start_date);
      const existingEnd = new Date(req.end_date);

      return newStart <= existingEnd && existingStart <= newEnd;
    });

    if (isOverlap) {
      toast.error('You already have a WFH request for selected dates');
      return;
    }

    try {
      const payload = {
        request_type: requestType,
        start_date: startDate,
        end_date: endDate,
        reason: reason,
      };

      const response = await httpInjectorService.createWfhRequest(payload);

      if (response?.status === 'success') {
        toast.success(response.message || 'Request Submitted Successfully');
        fetchWfhRequest();
        resetForm();
        onClose();
      } else {
        toast.error(response?.message || 'Date already exists');
      }
    } catch (error) {
      console.log('WFH request submission failed', error);
      toast.error('Something went wrong');
    }
  };

  const resetForm = () => {
    setStartDate('');
    setEndDate('');
    setReason('');
  };

  // DELETE WFH REQUEST
  const handleDelete = (requestId) => {
    setDeleteId(requestId);
    setOpenDeleteModal(true);
  };
  // if (!window.confirm('Are you sure you want to delete this WFH request?'))
  // return;
  const deleteWfhRequest = async () => {
    try {
      const response = await httpInjectorService.deleteWfhRequest(deleteId);

      if (response?.data?.status === 'success') {
        // setWorkFromHome((prev) => prev.filter((item) => item.id !== deleteId));
        setWorkFromHome((prev) =>
          prev.map((item) =>
            item.id === deleteId ? { ...item, status: 'Deleted' } : item,
          ),
        );
        toast.success('Deleted successfully');
      } else {
        toast.error(response?.data?.message || 'Delete failed');
      }
    } catch (error) {
      toast.error('Something went wrong');
    } finally {
      setOpenDeleteModal(false);
      setDeleteId(null);
    }
  };

  useEffect(() => {
    fetchWfhRequest();
  }, []);

  // TABLE COLUMNS
  const columns = useMemo(() => {
    const baseColumn = [
      // ...(role_id === 2
      ...(role_id === 2 || role_id === 1
        ? [
            {
              Header: (
                <Checkbox
                  colorScheme="purple"
                  isChecked={allSelected}
                  isIndeterminate={
                    selectedRequests.length > 0 &&
                    selectedRequests.length <
                      workFromHome.filter((r) => r.status === 'Pending').length
                  }
                  onChange={toggleAllSelection}
                />
              ),
              accessor: 'select',
              Cell: ({ row }) =>
                row.original.status === 'Pending' && (
                  <Checkbox
                    colorScheme="purple"
                    isChecked={selectedRequests.includes(row.original.id)}
                    onChange={() => toggleRowSelection(row.original.id)}
                  />
                ),
            },
          ]
        : []),

      // ...(role_id === 2
      ...(role_id === 2 || role_id === 1
        ? [
            { Header: 'Employee ID', accessor: 'employee_id' },
            { Header: 'Employee Name', accessor: 'username' },
          ]
        : []),
      { Header: 'Request type', accessor: 'request_type' },
      {
        Header: 'Start Date',
        accessor: 'start_date',
        Cell: ({ value }) => (value ? value.split('T')[0] : ''),
      },
      {
        Header: 'End Date',
        accessor: 'end_date',
        Cell: ({ value }) => (value ? value.split('T')[0] : ''),
      },
      { Header: 'Days', accessor: 'days' },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ value }) => (
          <Badge
            color={
              value === 'Pending'
                ? 'warning'
                : value === 'Approved'
                  ? 'success'
                  : value === 'Rejected'
                    ? 'danger'
                    : value === 'Deleted'
                      ? 'danger'
                      : 'danger'
            }
            pill
          >
            {value}
          </Badge>
        ),
      },
      {
        Header: 'Applied On',
        accessor: 'applied_on',
        Cell: ({ value }) => (value ? value.split('T')[0] : ''),
      },
    ];
    //user action column(beta user)
    if (role_id === 3) {
      baseColumn.push({
        Header: 'Action',
        Cell: ({ row }) => {
          const { status, id, reason, start_date, end_date } = row.original;
          // if (status !== 'Pending') return null;
          const isPending = status?.trim().toLowerCase() === 'pending';

          return (
            // <Flex gap={2} align="center" justify="center" w="100%">
            //   {isPending && (
            //     <>
            //       <Box onClick={() => handleDelete(row.original.id)}>
            //         <FiTrash2 />
            //       </Box>
            //       <Box
            //         cursor="pointer"
            //         color="gray.600"
            //         _hover={{ color: 'blue.500' }}
            //         onClick={() => {
            //           const rowData = row.original;

            //           setEditRequest({
            //             id: rowData.id,
            //             start_date: rowData.start_date?.split('T')[0],
            //             end_date: rowData.end_date?.split('T')[0],
            //             reason: rowData.reason,
            //           });
            //           onEditOpen();
            //         }}
            //       >
            //         <FiEdit size={18} />
            //       </Box>
            //     </>
            //   )}

            //   <Box
            //     cursor="pointer"
            //     color="gray.600"
            //     _hover={{ color: 'green.700' }}
            //     onClick={() => {
            //       setViewRequest(row.original);
            //       onviewOpen();
            //     }}
            //   >
            //     <ViewIcon Size={18} />
            //   </Box>
            // </Flex>
            <Flex gap={2} align="center" justify="center" w="100%">
              {isPending && (
                <>
                  <Button
                    size="xs"
                    colorScheme="green"
                    variant="solid"
                    borderRadius="md"
                    onClick={() => {
                      const rowData = row.original;
                      setEditRequest({
                        id: rowData.id,
                        start_date: rowData.start_date?.split('T')[0],
                        end_date: rowData.end_date?.split('T')[0],
                        reason: rowData.reason,
                      });
                      onEditOpen();
                    }}
                  >
                    <FiEdit size={14} />
                  </Button>
                  <Button
                    size="xs"
                    colorScheme="red"
                    variant="solid"
                    borderRadius="md"
                    onClick={() => handleDelete(row.original.id)}
                  >
                    <FiTrash2 size={14} />
                  </Button>
                </>
              )}

              <Button
                size="xs"
                colorScheme="blue"
                variant="solid"
                borderRadius="md"
                onClick={() => {
                  setViewRequest(row.original);
                  onviewOpen();
                }}
              >
                <ViewIcon boxSize={3} />
              </Button>
            </Flex>
          );
        },
      });
    }
    //admin action column
    // if (role_id === 2)
    if (role_id === 2 || role_id === 1) {
      baseColumn.push({
        Header: 'Action',
        Cell: ({ row }) => {
          const status = row.original.status;
          // if (status === 'Deleted') return null;
          return (
            <Flex gap={2} align="center" justify="center" w="100%">
              {status === 'Pending' && (
                <>
                  <Button
                    size="xs"
                    colorScheme="green"
                    variant="solid"
                    borderRadius="md"
                    // onClick={() => updateStatus(row.original.id, 'Approved')}
                    onClick={async () => {
                      const success = await updateStatus(
                        row.original.id,
                        'Approved',
                        row.original.user_id,
                      );
                      if (success) fetchWfhRequest();
                    }}
                  >
                    <CheckIcon boxSize={3} />
                  </Button>

                  <Button
                    size="xs"
                    colorScheme="red"
                    variant="solid"
                    borderRadius="md"
                    // onClick={() => updateStatus(row.original.id, 'Rejected')}
                    onClick={async () => {
                      const success = await updateStatus(
                        row.original.id,
                        'Rejected',
                        row.original.user_id,
                      );
                      if (success) fetchWfhRequest();
                    }}
                  >
                    <SmallCloseIcon boxSize={3} />
                  </Button>
                </>
              )}

              <Button
                size="xs"
                colorScheme="blue"
                variant="solid"
                borderRadius="md"
                onClick={() => {
                  setViewRequest(row.original);
                  onviewOpen();
                }}
              >
                <ViewIcon boxSize={3} />
              </Button>
            </Flex>
          );
        },
      });
    }
    return baseColumn;
  }, [role_id, selectedRequests, allSelected, workFromHome]);

  const handleUpdate = async () => {
    if (
      !editRequest?.start_date ||
      !editRequest?.end_date ||
      !editRequest?.reason
    ) {
      toast.error('All fields are required');
      return;
    }
    const start = new Date(editRequest.start_date);
    const end = new Date(editRequest.end_date);

    // NEW: check if dates overlap any other request
    if (isDateOverlap(start, end, editRequest.id)) {
      toast.error('Selected date overlaps with an existing WFH request');
      return; // stop update
    }
    try {
      const payload = {
        id: editRequest.id,
        start_date: editRequest.start_date,
        end_date: editRequest.end_date,
        reason: editRequest.reason,
      };

      const response = await httpInjectorService.updateWfhrequest(payload);

      if (response?.data?.status === 'success') {
        toast.success('Updated successfully');
        onEditClose();
        setEditRequest(null);
        fetchWfhRequest(); // for refresh
      } else {
        toast.error('Update failed');
      }
    } catch (error) {
      toast.error('Something went wrong');
    }
  };

  const updateStatus = async (wfhIds, status, userIds, showToast = true) => {
    try {
      const payload = { wfh_id: [wfhIds], status: status, user_ids: [userIds] };
      console.log('payload.....', payload);

      const response = await httpInjectorService.updateWfhStatus(payload);

      if (response?.status === 'success') {
        if (showToast) {
          if (status === 'Approved') {
            toast.success('Selected Request Approved');
          } else if (status === 'Rejected') {
            toast.success('Selected Request Rejected');
          } else {
            toast.success('Request Updated');
          }
        }
        fetchWfhRequest();
        return true;
      } else {
        if (showToast) toast.error(response.message || 'Request failed');
        return false;
      }
    } catch (error) {
      if (showToast) toast.error('Something went wrong');
      return false;
    }
  };

  return (
    <Box>
      {/*raise request modal create*/}
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Work From Home Request</ModalHeader>

          <ModalBody>
            <Text mb={6} color="gray.600">
              Fill out the form below to submit a WFH request.
            </Text>

            <FormControl mb={3}>
              <FormLabel>Request Type</FormLabel>
              <Input value={requestType} isReadOnly />
            </FormControl>

            <FormControl mb={3}>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </FormControl>

            <FormControl mb={3}>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </FormControl>

            <FormControl mb={3}>
              <FormLabel>Reason</FormLabel>
              <Textarea
                placeholder="Enter reason..."
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              size="sm"
              colorScheme="red"
              rounded="2"
              // borderRadius="full"

              onClick={() => {
                resetForm();
                onClose();
              }}
            >
              Cancel
            </Button>

            <Button
              size="sm"
              colorScheme="purple"
              // borderRadius="full"
              rounded="2"
              ml={3}
              onClick={submitRequest}
            >
              Submit Request
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* modal Update */}
      <Modal
        isOpen={isEditOpen}
        onClose={() => {
          onEditClose();
          setEditRequest(null);
        }}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edit WFH Request</ModalHeader>

          <ModalBody>
            <FormControl mb={3}>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={editRequest?.start_date || ''}
                onChange={(e) => {
                  const newStart = new Date(e.target.value);
                  const currentEnd = new Date(editRequest?.end_date);

                  if (
                    editRequest?.end_date &&
                    isDateOverlap(newStart, currentEnd, editRequest.id)
                  ) {
                    toast.error(
                      'Selected date overlaps with an existing request',
                    );
                    return;
                  }

                  setEditRequest({
                    ...editRequest,
                    start_date: e.target.value,
                  });
                }}
              />
            </FormControl>

            <FormControl mb={3}>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={editRequest?.end_date || ''}
                onChange={(e) => {
                  const newEnd = new Date(e.target.value);
                  const currentStart = new Date(editRequest?.start_date);

                  if (
                    editRequest?.start_date &&
                    isDateOverlap(currentStart, newEnd, editRequest.id)
                  ) {
                    toast.error(
                      'Selected date overlaps with an existing request',
                    );
                    return;
                  }

                  setEditRequest({ ...editRequest, end_date: e.target.value });
                }}
              />
            </FormControl>

            <FormControl mb={3}>
              <FormLabel>Reason</FormLabel>
              <Textarea
                value={editRequest?.reason || ''}
                onChange={(e) =>
                  setEditRequest({ ...editRequest, reason: e.target.value })
                }
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              size="sm"
              rounded="2"
              onClick={() => {
                onEditClose();
                setEditRequest(null);
              }}
            >
              Cancel
            </Button>

            <Button
              size="sm"
              colorScheme="purple"
              rounded="2"
              ml={3}
              onClick={handleUpdate}
            >
              Update
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* modal for beta user for delete confirm  */}

      <Modal
        size="md"
        isOpen={openDeleteModal}
        // onClose={() => setOpenDeleteModal(false)}
        toggle={() => setOpenDeleteModal(false)}
      >
        {/* <ModalOverlay /> */}
        <ModalContent>
          <ModalHeader onToggle={() => setOpenDeleteModal(false)}>
            Confirm Deletion
          </ModalHeader>

          <ModalBody>
            Are you sure you want to delete this WFH request?
          </ModalBody>

          <ModalFooter>
            <Button
              size="sm"
              rounded="2"
              colorScheme="purple"
              mr={3}
              onClick={() => setOpenDeleteModal(false)}
            >
              No
            </Button>

            <Button
              size="sm"
              rounded="2"
              colorScheme="red"
              onClick={deleteWfhRequest}
            >
              Yes
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* modal View for admin */}

      <Modal
        isOpen={isViewOpen}
        onClose={() => {
          onViewClose();
          setViewRequest(null);
        }}
        size="xl"
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <h5 className="mb-0">
              <b>Work From Home Request Details</b>
            </h5>
          </ModalHeader>

          <ModalCloseButton />

          <ModalBody>
            <Row className="mb-3">
              <Col>
                <h6>
                  <b>Employee Name:</b>
                </h6>
                <p className="mb-1">{viewRequest?.username}</p>
              </Col>

              <Col>
                <h6>
                  <b>Department:</b>
                </h6>
                <p className="mb-1">{viewRequest?.department_name}</p>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <h6>
                  <b>Designation:</b>
                </h6>
                <p className="mb-1">{viewRequest?.designations}</p>
              </Col>

              <Col>
                <h6>
                  <b>Total Days:</b>
                </h6>
                <p className="mb-1">{viewRequest?.days}</p>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <h6>
                  <b>Start Date:</b>
                </h6>
                <p>
                  {viewRequest?.start_date
                    ? viewRequest.start_date.split('T')[0]
                    : ''}
                </p>
              </Col>

              <Col>
                <h6>
                  <b>End Date:</b>
                </h6>
                <p>
                  {viewRequest?.end_date
                    ? viewRequest.end_date.split('T')[0]
                    : ''}
                </p>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <h6>
                  <b>Reason:</b>
                </h6>
                <p className="mb-1">{viewRequest?.reason}</p>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <h6>
                  <b>Actioned By:</b>
                </h6>
                <p className="mb-1">{viewRequest?.actioned_by}</p>
              </Col>

              <Col>
                <h6>
                  <b>Applied By:</b>
                </h6>
                <p className="mb-1">{viewRequest?.username}</p>
              </Col>
            </Row>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* table */}
      <Box p={2} mt={2}>
        {role_id === 3 && (
          <Flex justify="space-between" align="center">
            <Text fontWeight="bold" fontSize="lg" className="mx=1 mt-2">
              Apply For Work From Home
            </Text>

            <Button
              size="sm"
              colorScheme="purple"
              borderRadius="full"
              // px={6}
              rounded="2"
              leftIcon={<FiPlusCircle />}
              onClick={onOpen}
            >
              WFH Request
            </Button>
          </Flex>
        )}

        {/* Buttons Approve All, Reject All */}
        {(role_id === 2 || role_id === 1) && (
          <Flex align="center" mb={4} gap={3} mt={5}>
            <Text fontWeight="bold" fontSize="lg" className="mx=1 mt-2">
              Work From Home Logs
            </Text>

            <Flex ml="auto" gap={3}>
              <Button
                size="sm"
                colorScheme="purple"
                leftIcon={<FiPlusCircle />}
                onClick={onOpen}
                rounded="2"
                // style={{ marginRight: '10px' }}
                mr={2}
              >
                WFH Request
              </Button>
              <Button
                size="sm"
                colorScheme="purple"
                disabled={selectedRequests.length === 0}
                onClick={handleBulkApprove}
                rounded="2"
                // style={{ marginRight: '10px' }}
                mr={2}
              >
                Approve All
              </Button>
              <Button
                size="sm"
                colorScheme="red"
                disabled={selectedRequests.length === 0}
                onClick={handleBulkReject}
                rounded="2"
                // style={{ marginRight: '10px' }}
                mr={2}
              >
                Reject All
              </Button>
            </Flex>
          </Flex>
        )}

        {loading ? (
          <BulletList />
        ) : Array.isArray(workFromHome) && workFromHome.length > 0 ? (
          <TableContainer
            columns={columns}
            data={Array.isArray(workFromHome) ? workFromHome : []}
            isGlobalFilter={true}
            customPageSize={10}
            className="custom-header-css"
          />
        ) : (
          <Empty />
        )}
      </Box>
    </Box>
  );
};

export default WFHRequest;
